import { useQuery } from "@tanstack/react-query";
import { queryClient } from "shared/api/queryClient";
import { getLanguageAssistants } from "../api/getLanguageAssistant";

export const useLanguageAssistantsQuery = () => {
  return useQuery({
    queryKey: ["languageAssistants"],
    queryFn: () => {
      return getLanguageAssistants();
    },
  });
};

export const invalidateLanguageAssistantsQuery = () => {
  queryClient.invalidateQueries({ queryKey: ["languageAssistants"] });
};
